<template>
  <div class="line-special-base fortune-result">
    <h1><span>{{headInfo.title}}</span></h1>
    <div class="head-talk">
      <div class="fuki">
        <fukidashi-base :fuki-text="headInfo.comment2" arrow-direction="left" />
      </div>
      <img :src="basicData.pictures.pic2" alt="" :class="`lp-id--${hokatotoId}`">
    </div>
    <div class="result-panel-base">
      <div class="result-panel top-comm-1">
        <p v-html="fortuneResult.text1"></p>
      </div>

      <div class="result-fuki">
        <div class="fuki">
          <fukidashi-base :fuki-text="headInfo.comment3" arrow-direction="right" />
        </div>
        <img :src="basicData.pictures.pic3" alt="">
      </div>

      <div class="result-panel top-comm-2">
        <p v-html="fortuneResult.text2"></p>
      </div>

      <div class="btn-area">
        <span class="btn btn-subsc" @click="onSubscClick" ><span><span>{{btnFace}}</span></span></span>
      </div>
    </div>
  </div>
</template>

<script>
import { BASIC_DATA_BY_LPID } from '@/utvStore/components/recommend/lp/commons'
import FukidashiBase from '@/utvStore/components/recommend/line_special/partials/FukidashiBase'

export default {
  name: 'LineSpecialResult',
  components: {
    FukidashiBase,
  },
  props: {
    itemsId: {
      type: Number,
      default: 0,
    },
    hokatotoId: {
      type: Number,
      default: 0,
    },
    headInfo: {
      type: Object,
      default(){
        return {}
      },
    },
    fortuneResult: {
      type: Object,
      default(){
        return {}
      },
    },
    subscUrl:{
      type: String,
      default: '/'
    },
  },
  data(){
    return {
      btnFace: '占いTVでもっと占う',
    }
  },
  computed: {
    basicData(){
      return BASIC_DATA_BY_LPID[+this.hokatotoId].information.lineSpecial
    },
  },
  mounted(){
    console.log('id[%s] hokatoto[%s] headInfo:%O result:%O subscurl[%s]', this.itemsId, this.hokatotoId, this.headInfo, this.fortuneResult, this.subscUrl)
  },
  methods: {
    onSubscClick(){
      location.href = this.$handoverParams(this.subscUrl)
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";

.line-special-base {
  padding-top: 40px;
  color: #32373f;

  @include mq('w580'){
    font-size: 1.2em;
    line-height: 1.8em;
  }

  h1 {
    margin: 0 20px 16px;
    text-align: center;
    font-size: 24px;
    span {
      display: inline-block;
      position: relative;
      padding: 0 4px 8px;
      &::after {
        content: "";
        width: 100%;
        background: #69EDB2;
        height: 4px;
        border-radius: 4px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
  }

  .head-talk {
    position: relative;
    width: 100%;
    margin: 0;
    padding: 0;
    text-align: left;
    .fuki{
      width: 52%;
      height: 100%;
      position: absolute;
      right: 20px;
      top: 0;
      z-index: 11;
      display: flex;
      align-items: center;
    }
    img {
      position: relative;
      z-index: 10;
      display: inline-block;
      width: 45%;
      vertical-align: bottom;
      &.lp-id--5 { width: 56%; }
    }
  }

  .result-panel-base {
    width: 100%;
    background: url(/static/img/recommend/line_special/bg_lineSp01.png) no-repeat center top #3de375;
    background-size: 100% auto;
    padding: 24px 20px 60px;

    p {
      margin: 0 0 16px;
      background: white;
      border-radius: 16px;
      padding: 20px;
    }

    .result-fuki {
      position: relative;
      width: 100%;
      margin: 0;
      padding: 0;
      text-align: right;
      margin-bottom: 16px;
      .fuki{
        width: 68%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
      }
      img {
        position: relative;
        z-index: 10;
        display: inline-block;
        width: 30%;
        min-height: 100px;
        vertical-align: bottom;
      }
    }

    .btn-area {
      width: 100%;
      padding: 16px 40px;

      .btn {
        width: 100%;
        height: 55px;
        border: none;
        background: white;
        border-radius: 30px;
        font-weight: bold;
        color: #32373f;
        cursor: pointer;
        transition: all 200ms ease-out 0s;
        line-height: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        & > span {
          display: inline-block;
          position: relative;
          & > span {
            position: relative;
            z-index: 10;
            padding: 0 4px;
          }
          &::after {
            content: "";
            width: 100%;
            height: 8px;
            background: rgba(255, 244, 99, 0.75);
            display: inline-block;
            position: absolute;
            z-index: 1;
            bottom: -4px;
            left: 0;
          }
        }

        &.disable {
          color: #dadada;
          pointer-events: none;
          filter: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/utvStore/components/recommend/line_special/LineSpecialResult.vue